import compose from "recompose/compose";
import lifecycle from "recompose/lifecycle";
import withProps from "recompose/withProps";
import when from "recompose/branch";
import renderComponent from "recompose/renderComponent";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import formatPrismicData from "../../hocs/formatPrismicData";
import { withModel } from "../../data-providers/model";
import Shipping from "./Shipping";
import ShippingII from "./ShippingII";
import { withFormik } from "formik";
import {
  fetchShippingStates,
  fetchEstimatedDeliveryDate,
  isEstimatedDateLoading,
  getShippingDates,
  getRegionStates,
} from "./duck";
import { withUserOrders } from "../../data-providers/orders";

const enhanceCart = compose(
  withProps((props) => ({
    isTwoColumnLayout: props.model.prismicPageModel.isTwoColumnLayout,
  })),
  withFormik({
    mapPropsToValues: (props) => ({
      countryIso: props.model.countryModel.iso.toUpperCase(),
    }),
  }),
  connect(
    (state) => ({
      shippingDates: getShippingDates(state),
      isLoading: isEstimatedDateLoading(state),
    }),
    (dispatch) => ({
      updateEstimatedDeliveryDate: (params) =>
        dispatch(fetchEstimatedDeliveryDate(params)),
    })
  ),
  lifecycle({
    componentDidMount() {
      this.props.updateEstimatedDeliveryDate({
        country_iso: this.props.values.countryIso,
      });
      this.props.updateShippingStates(
        this.props.model.countryModel.iso.toUpperCase()
      );
    },
    componentDidUpdate(prevProps) {
      const prev = prevProps.values;
      const next = this.props.values;
      const isCountryDifferent = prev.countryIso !== next.countryIso;

      if (isCountryDifferent) {
        prevProps.setFieldValue("stateAbbr", null);
        prevProps.updateShippingStates(next.countryIso);
        prevProps.updateEstimatedDeliveryDate({
          country_iso: next.countryIso,
        });
      } else if (next.stateAbbr && prev.stateAbbr !== next.stateAbbr) {
        prevProps.updateEstimatedDeliveryDate({
          country_iso: next.countryIso,
          state_abbr: next.stateAbbr,
        });
      }
    },
  }),
  renderComponent(ShippingII)
);

const enhanceOrder = compose(
  withUserOrders,
  withRouter,
  withProps((props) => {
    const order = props.userOrders.response.ok
      ? props.userOrders.orders.find(
          (order) => order.id === props.match.params.orderNumber
        )
      : {};
    return {
      order,
      // TODO:
      // Eagle should just return this data as an array
      // instead of website handling this fugly transform
      shippingDates: order.shipping
        ? Object.keys(order.shipping.deliveryDate).map((key) => ({
            type: key,
            ...order.shipping.deliveryDate[key],
          }))
        : [],
    };
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.order.id !== this.props.order.id) {
        this.props.updateShippingStates(this.props.order.shipping.country_iso);
      }
    },
  })
);

const enhance = compose(
  formatPrismicData,
  withModel,
  connect(
    (state) => ({ regionStates: getRegionStates(state) }),
    (dispatch) => ({
      updateShippingStates: (country) => dispatch(fetchShippingStates(country)),
    })
  ),
  when((props) => props.infoType === "order-details", enhanceOrder, enhanceCart)
);

export default enhance(Shipping);
